import {selectAllEl} from "../marketing/utils";

document.addEventListener('DOMContentLoaded', function() {
    const accItem = selectAllEl(".acc-item");
    accItem.forEach((item, index) => {
        let accHeader = item.querySelector(".acc-item_header");
        accHeader.addEventListener("click", () => {
            let accBody = item.querySelector(".acc-item_body");
            if (!item.classList.contains("acc-item_active")) {
                item.classList.add("acc-item_active");
                accBody.style.maxHeight = accBody.scrollHeight + 32 + "px";
                accItem.forEach((element, ind) => {
                    let elementBody = element.querySelector(".acc-item_body");
                    if (!(ind === index)) {
                        element.classList.remove("acc-item_active");
                        elementBody.style.maxHeight = null;
                    }
                });
            } else {
                item.classList.remove("acc-item_active");
                accBody.style.maxHeight = null;
            }
        });
    });
})
